import React, { FC, RefObject, UIEvent } from 'react';
import classes from './styles/index.module.scss';
import classNames from 'classnames';

type CustomScrollBarProps = {
	className?: string;
	fullHeight?: boolean;
	onScroll?: (e: UIEvent<HTMLDivElement>) => void;
	scrollBarRef?: RefObject<HTMLDivElement>;
	dataTestId?: string;
};

export const CustomScrollBar: FC<React.PropsWithChildren<CustomScrollBarProps>> = ({
	className,
	fullHeight,
	onScroll,
	scrollBarRef,
	dataTestId,
	children,
}) => {
	const componentClasses = classNames(classes.customScrollBar, classes.customScrollBarVertical, className, {
		[classes.customScrollBar_fullHeight]: fullHeight,
	});

	const handleScroll = (e: UIEvent<HTMLDivElement>) => {
		onScroll && onScroll(e);
	};

	return (
		<div
			className={componentClasses}
			ref={scrollBarRef}
			onScroll={handleScroll}
			data-testid={dataTestId}
		>
			{children}
		</div>
	);
};
